export default __webpack_public_path__ + "static/media/lucasbbs.e90a667a.jpg";